import { createSlice } from "@reduxjs/toolkit";
import {
  ForgotPasswordAction,
  LoginAdminAction,
  LogOutAdminAction,
  ResetPasswordAction,
} from "store/middlewares/session/auth";
import { encryptAndStoreToken } from "utils/CryptoJS";
import LocalstorageService from "utils/localstorage-services";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loginMessage: "",
    forgotPass: false,
    resetPass: false,
    forgotPassWeb: null,
    registerUser: null,
    isOtpVerififed: false,
    isTokenValid: true,
    isWebTokenValid: true,
    registerEmail: "",
  },
  reducers: {
    resetForgetPass: (state) => {
      state.forgotPass = false;
    },
    resetResetPass: (state) => {
      state.resetPass = false;
    },
    resetOtpVerified: (state) => {
      state.isOtpVerififed = false;
    },
    resetForgetFlow: (state) => {
      state.forgotPassWeb = null;
      state.registerUser = null;
      state.isOtpVerififed = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(LoginAdminAction.pending, (state) => {
        state.loginMessage = "";
      })
      .addCase(LoginAdminAction.fulfilled, (state, action) => {
        let { response } = action.payload;

        console.log(response, "response");

        const localStorage = {
          user: {
            ...response,
            token: encryptAndStoreToken(response?.token),
            refreshToken: encryptAndStoreToken(response?.refreshToken),
          },
        };
        LocalstorageService.loginUser(localStorage);
        // state.loginMessage = action.payload.message;
        window.location = "/dashboard";
      })
      .addCase(LoginAdminAction.rejected, (state, action) => {
        state.loginMessage = action.payload.message;
      })
      .addCase(LogOutAdminAction.fulfilled, (state) => {
        state.loginMessage = "";
        LocalstorageService.removeFromLocalStorage("coupleAi-admin");
        window.location = "/";
      })
      //
      .addCase(ForgotPasswordAction.fulfilled, (state) => {
        state.forgotPass = true;
        state.resetPass = false;
      })
      .addCase(ResetPasswordAction.fulfilled, (state) => {
        state.forgotPass = false;
        state.resetPass = true;
      });
    //     .addCase(ValidateTokenAdmin.fulfilled, (state, action) => {
    //       state.isTokenValid = !action.payload.response.isTokenExpired;
    //     })
    //     .addCase(ValidateTokenAdmin.rejected, (state) => {
    //       state.isTokenValid = false;
    //     })
  },
});

export const {
  resetForgetPass,
  resetResetPass,
  resetOtpVerified,
  resetForgetFlow,
} = authSlice.actions;

export default authSlice.reducer;
